const lerp = (a, b, n) => (1 - n) * a + n * b;

class Cursor {
	constructor() {
		// config
		this.target = { x: 0.5, y: 0.5 }; // mouse position
		this.cursor = { x: 0.5, y: 0.5 }; // cursor position
		this.speed = 0.5;
		this.init();
	}
	makeCursor() {
		return new Promise((resolve) => {
			let cursor = `<div id="cursor" class="cursor"><div class="the_cursor"></div></div>`;
			document.body.insertAdjacentHTML("beforeend", cursor);
			resolve();
		});
	}
	bindAll() {
		["onMouseMove", "render"].forEach((fn) => (this[fn] = this[fn].bind(this)));
	}
	onMouseMove(e) {
		//get normalized mouse coordinates [0, 1]
		this.target.x = e.clientX / window.innerWidth;
		this.target.y = e.clientY / window.innerHeight;
		// trigger loop if no loop is active
		if (!this.raf) this.raf = requestAnimationFrame(this.render);
	}
	render() {
		//calculate lerped values
		this.cursor.x = lerp(this.cursor.x, this.target.x, this.speed);
		this.cursor.y = lerp(this.cursor.y, this.target.y, this.speed);
		document.documentElement.style.setProperty("--cursor-x", this.cursor.x);
		document.documentElement.style.setProperty("--cursor-y", this.cursor.y);
		//cancel loop if mouse stops moving
		const delta = Math.sqrt(Math.pow(this.target.x - this.cursor.x, 2) + Math.pow(this.target.y - this.cursor.y, 2));
		if (delta < 0.001) {
			cancelAnimationFrame(this.raf);
			this.raf = null;
			return;
		}
		//or continue looping if mouse is moving
		this.raf = requestAnimationFrame(this.render);
	}
	init() {
		this.bindAll();
		this.makeCursor().then(() => {
			window.addEventListener("mousemove", this.onMouseMove);
			this.raf = requestAnimationFrame(this.render);
		});
	}
}

class InitInstagram {
	constructor(params) {
		this.feed = params.feed;
		this.posts = params.posts;
		this.flux = params.container;
		this.init();
	}
	init() {
		if (this.flux) {
			fetch("https://www.juicer.io/api/feeds/" + this.feed)
				.then((data) => data.json())
				.then((res) => {
					let posts = res.posts.items.slice(0, this.posts);
					posts.map((item) => {
						let element = `<a href="${item.full_url}" target="_blank" rel="nofollow" class="image"><img src="${item.image}"  /></a>`;
						this.flux.innerHTML += element;
					});
				});
		}
	}
}

(function ($) {
	$(window).on("elementor/frontend/init", function () {
		new Cursor();
		AOS.init({
			offset: 200,
			once: false,
			mirror: false,
			duration: 700,
			easing: "ease-in-out-back",
		});
		$(document).on("click", ".uael-close-modal", function (event) {
			elementorProFrontend.modules.popup.closePopup({}, event);
		});
	});
})(jQuery);

window.addEventListener("DOMContentLoaded", () => {
	new InitInstagram({
		feed: "pronostics_sports_",
		posts: 5,
		container: document.querySelector(".block-instagram"),
	});

	let links = document.querySelectorAll("a");
	if (links) {
		links.forEach((el) => {
			el.addEventListener("mouseenter", () => {
				document.querySelector(".the_cursor").classList.add("clickable");
			});
			el.addEventListener("mouseleave", () => {
				document.querySelector(".the_cursor").classList.remove("clickable");
			});
		});
	}

	let swipers = document.querySelectorAll(".swiper-wrapper");
	if (swipers) {
		swipers.forEach((el) => {
			el.addEventListener("mouseenter", () => {
				document.querySelector(".the_cursor").classList.add("swipercursor");
			});
			el.addEventListener("mouseleave", () => {
				document.querySelector(".the_cursor").classList.remove("swipercursor");
			});
		});
	}

	let interactive = document.querySelectorAll(".filtre, .reset, select, input");
	if (interactive) {
		interactive.forEach((el) => {
			el.addEventListener("mouseenter", () => {
				document.querySelector(".the_cursor").classList.add("interactive");
			});
			el.addEventListener("mouseleave", () => {
				document.querySelector(".the_cursor").classList.remove("interactive");
			});
		});
	}
});
